import { formatLayoutVariantCount } from "entities/configurator/model/layoutChoiceName";
import {
  getLayoutBrowseGroup,
  isSameLayoutBrowseGroup,
} from "entities/configurator/model/layoutMeta";
import classNames from "classnames";
import React from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";
import DoorOptionsIcon, { DoorOptionsType } from "shared/ui/door-options-icons";
import { SelectionWrapper } from "../SelectionWrapper";
import { useLayoutSelector } from "./hooks/useLayoutSelector";

export const DoorOptionsControlsList = React.memo(() => {
  const {
    hasNewLayoutsOption,
    sortedLayoutList,
    getLayoutSubchoiceCount,
    onChangeLayout,
    searchParams,
    getDisplayName,
  } = useLayoutSelector();
  const selectedCode = searchParams.get("layout");

  return (
    <SelectionWrapper
      className={classNames("", {
        "gg-flex-wrap-reverse": hasNewLayoutsOption,
      })}
    >
      {sortedLayoutList.map((layout: OptionTemplate) => {
        const layoutName = getDisplayName(layout);
        const layoutGroup = getLayoutBrowseGroup(layout.code);
        const subchoiceCount = getLayoutSubchoiceCount(layout.code);
        const helperText =
          layout.code === "eigenwijs"
            ? "Eigen ontwerp"
            : subchoiceCount > 0
              ? formatLayoutVariantCount(subchoiceCount)
              : undefined;
        const accessibleName = helperText
          ? `${layoutName}, ${helperText}`
          : layoutName;
        const isSelectedGroup = isSameLayoutBrowseGroup(
          layout.code,
          selectedCode,
        );
        const isActive = layout.code === selectedCode || isSelectedGroup;

        return (
          <button
            key={layout.code}
            type="button"
            className={classNames(
              "gg-flex gg-max-w-min gg-flex-col gg-text-left",
              {
                "gg-self-end": hasNewLayoutsOption,
              },
            )}
            onClick={() => onChangeLayout(layout)}
            aria-label={accessibleName}
            data-layout-group={layoutGroup ?? undefined}
            data-testid={`door-layout-option-${layout.code}`}
          >
            <DoorOptionsIcon
              selectedDoor={layout.code as DoorOptionsType}
              isActive={isActive}
            />
            <span className="gg-pt-1 gg-text-xs gg-font-semibold gg-leading-4 gg-tracking-wide gg-text-primary-color">
              {layoutName}
            </span>
            {helperText && (
              <span className="gg-mt-1 gg-text-xs gg-text-secondary-text">
                {helperText}
              </span>
            )}
          </button>
        );
      })}
    </SelectionWrapper>
  );
});
